(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.header.classList.add('shopify-section-header-sticky');

      // ResizeObserver reports the header's size after layout happens naturally,
      // instead of us forcing a synchronous layout read (offsetHeight) ourselves -
      // that forced reflow showed up in Lighthouse. It also keeps --header-height
      // correct for every future size change (breakpoint, font load, menu edits),
      // not just window load and the one 990px breakpoint the old code checked.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver((entries) => {
          var box = entries[0].borderBoxSize;
          var height = box ? (Array.isArray(box) ? box[0].blockSize : box.blockSize) : entries[0].contentRect.height;
          if (height > 0) {
            document.documentElement.style.setProperty('--header-height', `${height}px`);
          }
        });
        this.resizeObserver.observe(this.header);
      } else {
        this.setHeaderHeight();
        window.addEventListener('load', this.setHeaderHeight.bind(this));
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setHeaderHeight() {
      var height = this.header.offsetHeight;
      if (height > 0) {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    /* Spolehlivě vypnout blur headeru, když je menu otevřené (záloha k :has()) */
    const drawerContainer = document.querySelector('.menu-drawer-container');
    if (drawerContainer) {
      const syncDrawerClass = () => {
        document.body.classList.toggle('drawer-open', drawerContainer.classList.contains('menu-opening'));
      };
      new MutationObserver(syncDrawerClass).observe(drawerContainer, { attributes: true, attributeFilter: ['class'] });
      syncDrawerClass();
    }

    const mobileMenu = document.querySelector('.menu-drawer__menu');
    if (mobileMenu) {
      const links = mobileMenu.querySelectorAll('.menu-drawer__menu-item');
      links.forEach(link => {
        if (link.textContent.trim().toLowerCase() === 'help') link.textContent = 'FAQ';
      });
    }

    const currentPath = window.location.pathname;
    const menuLinks = document.querySelectorAll('.list-menu__item--link, .header__menu-item, .menu-drawer__menu-item');

    menuLinks.forEach(function (link) {
      try {
        const linkPath = new URL(link.href, window.location.origin).pathname;
        if (linkPath === currentPath || (currentPath !== '/' && currentPath.startsWith(linkPath) && linkPath !== '/')) {
          link.classList.add('active-menu-item');
        }
      } catch(e) {}
    });

    /* =====================================================================
       ZAVÍRÁNÍ MENU – VŽDY PŘES DAWN

       Klíčové: zavíráme jen voláním summary.click(). Dawn si tím sám
       odebere .menu-opening (spustí naše CSS animace = panel sjede, overlay
       zfadne), zruší zámek scrollu a po dohrání animace odebere [open].
       Žádnou vlastní práci s atributem [open] neděláme → nic se
       nerozsynchronizuje a menu se po kliknutí znovu neotevírá.
       ===================================================================== */
    const menuDrawerEl = document.querySelector('.menu-drawer');
    const panel = document.querySelector('.menu-drawer__inner-container');
    const summary = document.querySelector('header-drawer details > summary');

    function closeMenu() {
      const detailsEl = document.querySelector('.menu-drawer-container');
      // Zavřeme jen pokud je menu reálně otevřené
      if (summary && detailsEl && detailsEl.hasAttribute('open')) {
        summary.click();
      }
    }

    /* Klik na tmavé pozadí (mimo bílý panel) = zavřít */
    if (menuDrawerEl && panel) {
      menuDrawerEl.addEventListener('click', function (e) {
        if (panel.contains(e.target)) return; // klik dovnitř panelu → nic
        closeMenu();
      });
    }

    /* Tažení madla / horní části panelu dolů = zavřít */
    if (panel && summary) {
      let startY = 0, currentY = 0, dragging = false, atTop = false;

      panel.addEventListener('touchstart', function (e) {
        atTop = panel.scrollTop <= 0;
        startY = e.touches[0].clientY;
        currentY = 0;
        dragging = false;
      }, { passive: true });

      panel.addEventListener('touchmove', function (e) {
        if (!atTop) return;
        const delta = e.touches[0].clientY - startY;
        if (delta > 0) {
          dragging = true;
          currentY = delta;
          panel.style.setProperty('transition', 'none', 'important');
          panel.style.setProperty('transform', 'translateY(' + delta + 'px)', 'important');
          e.preventDefault();
        }
      }, { passive: false });

      panel.addEventListener('touchend', function () {
        if (!dragging) return;
        if (currentY > 110) {
          // Dotáhnout dolů a nechat Dawn zavřít
          panel.style.setProperty('transition', 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)', 'important');
          panel.style.setProperty('transform', 'translateY(100%)', 'important');
          closeMenu();
          setTimeout(function () {
            panel.style.removeProperty('transform');
            panel.style.removeProperty('transition');
          }, 450);
        } else {
          // Snap zpátky nahoru
          panel.style.setProperty('transition', 'transform 0.35s cubic-bezier(0.16, 1, 0.3, 1)', 'important');
          panel.style.setProperty('transform', 'translateY(0)', 'important');
          setTimeout(function () {
            panel.style.removeProperty('transform');
            panel.style.removeProperty('transition');
          }, 400);
        }
        dragging = false;
        currentY = 0;
      }, { passive: true });
    }
  });

  (function() {
    const refreshCartHeader = () => {
      const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      fetch(`${rootUrl}?sections=header`)
        .then(response => response.json())
        .then(sections => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(sections['header'], 'text/html');
          const newCartIconContent = htmlDoc.querySelector('#cart-icon-bubble');
          const currentCartIcon = document.querySelector('#cart-icon-bubble');
          
          if (newCartIconContent && currentCartIcon) {
            currentCartIcon.innerHTML = newCartIconContent.innerHTML;
          }
        })
        .catch(err => console.error('Chyba při AJAX aktualizaci košíku:', err));
    };

    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const response = await originalFetch(...args);
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear') || url.includes('/cart/update'))) {
        refreshCartHeader();
      }
      return response;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.addEventListener('load', function() {
        if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear') || url.includes('/cart/update'))) {
          refreshCartHeader();
        }
      });
      return originalOpen.apply(this, arguments);
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
